// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "passengers-39fsv";
var _5 = "passenger-2u_0X";
var _6 = "passengers_started-3BZqx";
var _7 = "registeredPassenger-1Hgxy";
var _8 = "slider-2rwJP";
var _9 = "addPassenger__addButton_startIcon-2MJQQ";
var _a = "selectedPassenger__deleteButton-y2NGc";
var _b = "passengers_confirmed-1juBg";
var _c = "segment-2ZG9Y";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "passengers", _5 as "passenger", _6 as "passengers_started", _7 as "registeredPassenger", _8 as "slider", _9 as "addPassenger__addButton_startIcon", _a as "selectedPassenger__deleteButton", _b as "passengers_confirmed", _c as "segment" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "passengers": _4, "passenger": _5, "passengers_started": _6, "registeredPassenger": _7, "slider": _8, "addPassenger__addButton_startIcon": _9, "selectedPassenger__deleteButton": _a, "passengers_confirmed": _b, "segment": _c }
